export default "__VITE_ASSET__20bba35e__"